import React, { useState, useRef } from "react";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "../../components/mensajes";
import { formatMoneda, validaSoloNumero } from "../../util/varios";
import moment from "moment";
import useTable from "../../components/useTable";
import { Dimmer } from "../../components/spinner";
import CatalogoCuentaBancaria from "../../catalogos/catalogoCuentaBancarias";
import { IncluirMovimiento } from "./ModalIncluirMoviTransi";
import { Input, SearchInput } from "../../ui/inputs/Input";
import { PrimaryButton } from "../../ui/buttons/Button";

const TablaMovimientosTransito = (props) => {
  var op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const headCells = [
    {
      id: "idmovimientosentransito",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "COD.",
      textAlign: "center",
    },
    {
      id: "tipomov",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "TIPO",
      textAlign: "center",
    },
    {
      id: "referencia",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "REFERENCIA",
      textAlign: "center",
    },
    {
      id: "fecha",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "FECHA",
      textAlign: "center",
    },
    {
      id: "monto",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "MONTO",
      textAlign: "center",
    },
    {
      id: "opciones",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: " OPCIONES",
      textAlign: "center",
    },
  ];

  const txtIdCuentaBancaria = useRef();
  const txtCuenta = useRef();

  const txtBuscador = useRef();

  const [operacion, setOperacion] = useState(0);
  const [catalogoCuenta, setCatalogoCuenta] = useState(false);

  const [mostrar, setMostrar] = useState(false);
  const [habilitado, setHabilitado] = useState(false);
  const [idMovimiento] = useState("0");
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [records, setRecords] = useState([]);
  const [regDet, setRegDet] = useState();

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) => {
            st = x.status === "51" ? "activo" : "inactivo";
            if (
              x.idmovimientosentransito.includes(target.value) ||
              x.tipomov.toLowerCase().includes(target.value.toLowerCase()) ||
              x.referencia.toLowerCase().includes(target.value.toLowerCase()) ||
              moment.utc(x.fecha)
                .format("DD/MM/YYYY")
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              formatMoneda(
                x.monto.toString().replace(",", "").replace(".", ","),
                ",",
                ".",
                2
              )
                .toLowerCase()
                .includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
      },
    });
  };

  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

  const seleccionarCuentaBancaria = (id) => {
    let campos = "*";
    let nomtab = "cuentabancaria";
    let nomid = "idcuentabancaria";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid} `;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            txtCuenta.current.value =
              response.data.nombre.trim() +
              " --- " +
              response.data.cuentabancaria.trim();
            seleccionarMovimientos(response.data.idcuentabancaria);
            setTimeout(() => txtBuscador.current.focus(), 200);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "ID no existe.",
              icono: "informacion",
            });
            txtIdCuentaBancaria.current.value = "";
            txtIdCuentaBancaria.current.focus();
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarMovimientos = (id) => {
    let campos = "*";
    let nomtab = "movimientosentransito";
    let nomid = "idcuentabancaria";
    let condic = "true";

    let endpoint = `${op.conexion}/api/consulta/modelicondi?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}&condic=${condic}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setRecords([]);
          if (response.data.length > 0) {
            var mov = [];
            for (let i = 0; i < response.data.length; i++) {
              console.log(response.data[i]);
              mov.push({
                idmovimientosentransito:
                  response.data[i].idmovimientosentransito,
                idcuentabancaria: response.data[i].idcuentabancaria,
                fecha: response.data[i].fecha,
                fechasis: response.data[i].fechasis,
                referencia: response.data[i].referencia,
                motivo: response.data[i].motivo,
                monto: response.data[i].monto,
                tipo: response.data[i].tipo,
                reversado: response.data[i].reversado,
                conciliado: response.data[i].conciliado,
                fechareversado: response.data[i].fechareversado,
                fechaconciliacion: response.data[i].fechaconciliacion,
                tipomov:
                  parseInt(response.data[i].tipo) === 0
                    ? "DEPOSITO"
                    : parseInt(response.data[i].tipo) === 1
                    ? "TRANSFERENCIA"
                    : parseInt(response.data[i].tipo) === 2
                    ? "NOTA CREDITO"
                    : parseInt(response.data[i].tipo) === 3
                    ? "NOTA DEBITO"
                    : "CHEQUE",
              });
            }
            setRecords(mov);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const gestionarMovimiento = (op, id, index) => (e) => {
    if (op === 4) {
      setHabilitado(false);
      setOperacion(4);
      var mov = records;
      var mov = mov.filter(function (mov) {
        return mov.idmovimientosentransito === id;
      });
      setRegDet(mov[0]);
      setMostrar(true);
    } else if (op === 1) {
      if (
        txtIdCuentaBancaria.current.value === "" ||
        txtCuenta.current.value === ""
      ) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe seleccionar una Cuenta Bancaaria.",
          icono: "informacion",
        });
      }
      setOperacion(op);
      setHabilitado(true);
      setMostrar(true);
    } else if (op === 2) {
      setHabilitado(false);
      setOperacion(4);
      var mov = records;
      var mov = mov.filter(function (mov) {
        return mov.idmovimientosentransito === id;
      });
      console.log(parseInt(mov[0].conciliado));
      if (parseInt(mov[0].conciliado) === 1) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "El movimiento no se puede modificar, ya está conciliado.",
          icono: "informacion",
        });
      }
      setRegDet(mov[0]);
      setMostrar(true);
    } else if (op === 3) {
      setOperacion(op);
      setHabilitado(false);
      var mov = records;
      var mov = mov.filter(function (mov) {
        return mov.idmovimientosentransito === id;
      });
      if (mov[0].conciliado === 1) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "El movimiento no se puede eliminar, ya está conciliado.",
          icono: "informacion",
        });
      }
      setRegDet(mov[0]);
      setMostrar(true);
    }
  };
  const handleCloseSi = () => {
    setActivate(false);
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };
  const validarCuenta = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarCuentaBancaria(event.target.value);
      } else {
        txtCuenta.current.value = "";
      }
    }
  };

  const onChange = (e) => {
    if (e.target.name === "idcuentabancaria") {
      txtCuenta.current.value = "";
      setRecords([]);
    }
  };

  const onCatalogoCuenta = (values) => {
    setCatalogoCuenta(false);
    txtIdCuentaBancaria.current.value = values.idcuentabancaria;
    seleccionarCuentaBancaria(values.idcuentabancaria);
  };

  const exitHandler = () => {
    props.setTabla(0);
  };
  return (
    <div style={{ height: "100%", width: "100%" }}>
      <div className="row col-md-12 py-3" style={{ margin: 0 }}>
        <div className="row col-md-7 mx-auto" style={{ margin: 0 }}>
          <div className="col-md-12 py-1 mx-auto card shadow ">
            <div className="col-md-12 row mx-auto  rounded py-3">
              <header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top">
                <h3 className="fw-bold m-0">Gestion de Movimientos Transito</h3>
                <a href="#" onClick={exitHandler} className="text-light fw-bold fs-6">
                  Salir <i className="fas fa-times ms-2"></i>
                </a>
              </header>
              <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded gap-2">
                <legend className="float-none w-auto m-0">Cuenta Bancaria</legend>
                <div className="col-4 m-0 p-0">
                  <SearchInput label = 'Código:'
                    name="idcuentabancaria"
                    onKeyUp={validarCuenta}
                    onBlur={validarCuenta}
                    onChange={onChange}
                    onClickButton={()=>{setCatalogoCuenta(true)}}
                    ref={txtIdCuentaBancaria}
                  />
                </div>
                <div className="col m-0 p-0">
                  <Input
                    disabled
                    name="cuentabancaria"
                    ref={txtCuenta}
                  />
                </div>
              </fieldset>
              <fieldset className="col-12 m-0 p-2 d-flex flex-wrap justify-content-between align-items-center border-azul rounded gap-2">
                <legend className="float-none w-auto m-0">Movimientos</legend>
                <div className="col-4 m-0 p-0">
                  <SearchInput 
                    onChange={handleSearch}
                    placeholder="Buscar"
                    ref={txtBuscador}
                  />
                </div>
                <div className="col-auto m-0 p-0">
                  <PrimaryButton icon = 'fa-plus m-0'
                    onClick={gestionarMovimiento(1, "")}
                  >
                  </PrimaryButton>
                </div>
                <div className="col-12 m-0 p-0">
                  <TblContainer>
                    <TblHead />
                    <tbody>
                      {records &&
                        recordsAfterPagingAndSorting().map((item, index) => (
                          <tr key={index} style={{ padding: "0" }}>
                            <td
                              className="align-baseline"
                              style={{
                                textAlign: "center",
                                alignItems: "center",
                                width: "240px",
                              }}
                            >
                              {item.idmovimientosentransito}
                            </td>
                            <td
                              className="align-baseline"
                              style={{
                                textAlign: "center",
                                alignItems: "center",
                                width: "240px",
                              }}
                            >
                              {item.tipomov}
                            </td>
                            <td
                              className="align-baseline"
                              style={{
                                textAlign: "center",
                                alignItems: "center",
                                width: "240px",
                              }}
                            >
                              {item.referencia}
                            </td>
                            <td
                              className="align-baseline"
                              style={{
                                textAlign: "center",
                                alignItems: "center",
                                width: "270px",
                              }}
                            >
                              {moment.utc(item.fecha).format("DD/MM/YYYY")}
                            </td>
                            <td
                              className="align-baseline"
                              style={{
                                textAlign: "center",
                                alignItems: "center",
                                width: "270px",
                              }}
                            >
                              {formatMoneda(
                                item.monto
                                  .toString()
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                            </td>
                            <td
                              className="align-baseline"
                              style={{
                                textAlign: "center",
                                alignItems: "center",
                                width: "330px",
                              }}
                            >
                              <button
                                onClick={gestionarMovimiento(
                                  4,
                                  item.idmovimientosentransito,
                                  index
                                )}
                                className="btn btn-sm mx-1 btn-info rounded-circle"
                              >
                                <i className="fas fa-eye"></i>{" "}
                              </button>
                              <button
                                onClick={gestionarMovimiento(
                                  2,
                                  item.idmovimientosentransito,
                                  index
                                )}
                                className="btn btn-sm mx-1 btn-warning rounded-circle"
                              >
                                <i className="fa fa-edit"></i>{" "}
                              </button>
                              <button
                                onClick={gestionarMovimiento(
                                  3,
                                  item.idmovimientosentransito,
                                  index
                                )}
                                className="btn btn-sm mx-1 btn-danger rounded-circle"
                              >
                                <i className="fa fa-trash"></i>{" "}
                              </button>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </TblContainer>
                  <TblPagination />
                </div>
              </fieldset>
            </div>
          </div>
        </div>
      </div>
      <IncluirMovimiento
        show={mostrar}
        operacion={operacion}
        idcuentabancaria={
          txtIdCuentaBancaria.current ? txtIdCuentaBancaria.current.value : "0"
        }
        idmovimiento={idMovimiento}
        habilitado={habilitado}
        registro={regDet}
        onHideCancela={() => {
          setMostrar(false);
        }}
        onHideRenderizar={() => {
          seleccionarMovimientos(txtIdCuentaBancaria.current.value);
        }}
      />
      <CatalogoCuentaBancaria
        show={catalogoCuenta}
        onHideCancelar={() => {
          setCatalogoCuenta(false);
        }}
        onHideAceptaCatalogo={onCatalogoCuenta}
      />

      <Dimmer active={activate} inverted></Dimmer>

      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </div>
  );
};
export default TablaMovimientosTransito;
